import { Header2, Header4 } from '@cian/ui-kit/typography';
import React, { memo } from 'react';

import styles from './CommercialTitle.css';
import { GeneralInfoSectionRow } from '../../GeneralInfoSectionRow';

interface ICommercialTitleProps {
  promoTitle?: string;
  typedTitle: string;
  href: string;
  rel?: string;
  isPromoted?: boolean;
}

export const CommercialTitleComponent: React.FC<ICommercialTitleProps> = ({
  promoTitle,
  typedTitle,
  href,
  rel = 'noreferrer',
  isPromoted = false,
}) => {
  const target = rel?.includes('noreferrer') ? '_blank' : undefined;
  const mainColor = isPromoted ? 'accent-main-primary' : 'text-primary-default';

  return (
    <GeneralInfoSectionRow>
      <a className={styles['link']} href={href} target={target} rel={rel} data-name="CommercialTitleComponent">
        {promoTitle ? (
          <>
            <Header2 data-mark="CommercialPromoTitle" color={mainColor}>
              {promoTitle}
            </Header2>
            <div className={styles['typed']}>
              <Header4 data-mark="CommercialTypedTitle" color="text-primary-default">
                {typedTitle}
              </Header4>
            </div>
          </>
        ) : (
          <Header2 data-mark="CommercialTypedTitle" color={mainColor}>
            {typedTitle}
          </Header2>
        )}
      </a>
    </GeneralInfoSectionRow>
  );
};

CommercialTitleComponent.displayName = 'CommercialTitle';

export const CommercialTitle = memo(CommercialTitleComponent);
